import { Component, OnInit, OnDestroy, HostListener, PLATFORM_ID, Inject, afterNextRender } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule } from '@angular/router';


interface CarouselSlide {
  title: string;
  description: string;
  img: string;
}

@Component({
  selector: 'app-home-slider',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './home-slider.component.html',
  styleUrls: ['./home-slider.component.scss']
})
export class HomeSliderComponent implements OnInit, OnDestroy {
    isMobile = false;
    currentSlideIndex = 0;
    private autoSlideInterval: any;

    carouselSlides: CarouselSlide[] = [
    {
      title: "SÉCURITÉ",
      description: "Gardiennage - Contrôle des accès",
      img: "./assets/images/home_main.png"
    },
    {
      title: "PROTECTION",
      description: "Surveillance et protection de biens mobiliers et immobiliers...",
      img: "./assets/images/home_main.png"
    },
     {
      title: "CONTRÔLE",
      description: "Surveillance et contrôle des personnes dans le cadre du maintien de...",
      img: "./assets/images/home_main.png"
    }
  ];

  constructor(@Inject(PLATFORM_ID) private platformId: Object){
    afterNextRender(() => {
      this.checkScreenSize();
      this.startAutoSlide();
    });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.stopAutoSlide();
  }

  @HostListener('window:resize')
  checkScreenSize() {
    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = window.innerWidth <= 768;
    }
  }

  @HostListener('window:wheel', ['$event'])
  onScroll(event: WheelEvent) {
    if (!isPlatformBrowser(this.platformId)) { return; }
    if (this.isMobile) {
      //event.preventDefault();
      /*if (event.deltaY > 0) {
        this.nextSlide();
      } else {
        this.previousSlide();
      }*/
     }
  }

  @HostListener('touchstart', ['$event'])
  @HostListener('touchend', ['$event'])
  handleTouch(event: TouchEvent) {
    if (!isPlatformBrowser(this.platformId)) { return; }
    if (!this.isMobile) return;
    
    const touch = event.touches[0] || event.changedTouches[0];
    if (event.type === 'touchstart') {
      this.touchStartY = touch.clientY;
    } else if (event.type === 'touchend') {
      this.touchEndY = touch.clientY;
      this.handleSwipe();
    }
  }

  private touchStartY = 0;
  private touchEndY = 0;

  private handleSwipe() {
    const diff = this.touchStartY - this.touchEndY;
    const minSwipeDistance = 50;

    if (Math.abs(diff) > minSwipeDistance) {
      if (diff > 0) {
        this.nextSlide();
      } else {
        this.previousSlide();
      }
    }
  }

  startAutoSlide() {
    if (isPlatformBrowser(this.platformId)) {
      this.autoSlideInterval = setInterval(() => {
        this.nextSlide();
      }, 5000);
    }
  }

  stopAutoSlide() {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
    }
  }

  nextSlide() {
    this.currentSlideIndex = (this.currentSlideIndex + 1) % this.carouselSlides.length;
    this.restartAutoSlide();
  }

  previousSlide() {
    this.currentSlideIndex = this.currentSlideIndex === 0 
      ? this.carouselSlides.length - 1 
      : this.currentSlideIndex - 1;
    this.restartAutoSlide();
  }

  goToSlide(index: number) {
    this.currentSlideIndex = index;
    this.restartAutoSlide();
  }

  private restartAutoSlide() {
    this.stopAutoSlide();
    this.startAutoSlide();
  }
}